import { booleanAttribute, Directive, Input } from '@angular/core';

/**
 * Directive that allows a button to be styled as disabled while remaining interactive.
 *
 * When used with the `disabled` input, the button will be styled as disabled
 * but remain tabbable and interactive for keyboard/screen reader users.
 *
 * @example
 * <button
 *   class="btn primary-btn"
 *   [disabled]="isSaving"
 *   disabledInteractive
 *   (click)="onSave()">
 *   Save
 * </button>
 */
@Directive({
	selector: '[disabledInteractive]',
	standalone: true,
	host: {
		'[attr.disabled]': '_getDisabledAttribute()',
		'[attr.aria-disabled]': '_getAriaDisabled()',
		'[class.disabled-interactive]': 'disabled && disabledInteractive'
	}
})
export class DisabledInteractiveDirective {
	@Input({ transform: booleanAttribute })
	public disabled = false;

	@Input({ transform: booleanAttribute })
	public disabledInteractive = false;

	protected _getDisabledAttribute (): boolean | null {
		return this.disabledInteractive || !this.disabled ? null : true;
	}

	protected _getAriaDisabled (): string | null {
		return this.disabled && this.disabledInteractive ? 'true' : null;
	}
}
